import websiteContent from './website-content.json';

export interface SocialLink {
    id: string;
    href: string;
    icon: string;
    title: string;
}

// Import social links from centralized content
export const socialLinks: SocialLink[] = websiteContent.social.links;